import { api } from '@/lib/api'

import { ContractorOffCycleDetails } from '../types'

export function getOffCycleDetails() {
  return api.get<ContractorOffCycleDetails>(
    `/v1/me/contractor-payments/off-cycle`,
  )
}
